import { Button } from "@app/scripts/react-general-components/Button";
import { Drawer } from "@app/scripts/react-general-components/Drawer";
import { useLocaleContext } from "@app/scripts/react-providers/locales";
import { ClearAll, Filters, useResults } from "@usereactify/search";
import React, { useCallback, useEffect } from "react";

import { FilterList } from "@app/scripts/reactify/filters/FilterList";
import { FilterRange } from "@app/scripts/reactify/filters/FilterRange";
import { FilterSortSort } from "@app/scripts/reactify/filters/FilterSortSort";

export const FilterSortDrawer: React.FC = ({ collection, className, locale }) => {
  const { facets } = useLocaleContext();

  return (
    <Drawer
      drawerClassName={`filter-sort-drawer ${className || ""}`}
      heading={facets?.filter_and_sort || "Filter & sort"}
      opensFrom="left"
      destroyOnHide={false}
      preventScroll={false}
      customButton={OpenButton}
      drawerHeaderButton={() => (
        <ClearAll
          render={(props) => (
            <Button
              label={facets?.clear_all || "Clear All"}
              className="hide-mobile filter-sort-drawer__clear-all-top"
              onClick={props.clearAll}
              variant="text"
            />
          )}
        />
      )}
      inline
      disableOverlay
    >
      <Content />
    </Drawer>
  );
};

const OpenButton = ({ toggleOpen }) => {
  const handleToggleOpen = useCallback(() => {
    toggleOpen?.();
  }, [toggleOpen]);

  // Add a listener from the collection banner to trigger the drawer
  useEffect(() => {
    document
      .querySelectorAll(".collection-hero__filters")
      ?.forEach((btn) => btn.addEventListener("click", handleToggleOpen));
    return () => {
      document
        .querySelectorAll(".collection-hero__filters")
        ?.forEach((btn) => btn.removeEventListener("click", handleToggleOpen));
    };
  }, [toggleOpen]);

  return null;
};

type Props = {
  toggleOpen?: () => void;
};

const Content: React.FC<Props> = ({ toggleOpen }) => {
  const { resultStats } = useResults();
  const { facets } = useLocaleContext();

  const noResultsText = facets?.no_results?.split("{{ clear }}") || ["No results found, try ", "the filters"];

  return (
    <>
      <ui-accordion>
        <ul className="accordion-container rs__filters">
          <FilterSortSort />
          <Filters renderFilterList={FilterList} renderFilterRange={FilterRange} />
        </ul>
      </ui-accordion>

      <div className="filter-sort-drawer__result-wrap">
        <ClearAll
          render={(props) => (
            <Button
              label={facets?.clear_all || "Clear All"}
              className="hide-desktop filter-sort-drawer__clear-all button"
              onClick={props.clearAll}
              color="outline"
            />
          )}
        />
        {resultStats?.numberOfResults ? (
          <Button
            onClick={toggleOpen}
            className="filter-sort-drawer__show-results"
            variant="secondary"
            label={`View ${resultStats.numberOfResults} product${resultStats.numberOfResults > 1 ? "s" : ""}`}
          />
        ) : (
          <div className="text-sm">
            {noResultsText[0]}{" "}
            <ClearAll
              render={(props) => (
                <Button
                  className="filter-sort-drawer__clear-text"
                  label={facets?.no_results_clear || "clearing"}
                  variant="text"
                  onClick={props.clearAll}
                />
              )}
            />{" "}
            {noResultsText[1]}
          </div>
        )}
      </div>
    </>
  );
};
